var ___EXPOSE_LOADER_IMPORT___ = require("-!./webpack_mindbreeze_object_client.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["Mindbreeze"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["Mindbreeze"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
